import * as React from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion'
import { Label } from '@/components/ui/label'
import { Switch } from '@/components/ui/switch'

/**
 * A toggle with an inline accordion for its dependent field, org mode only
 * (e.g. "Enabled for Angelica" / "Enabled for David" + their instructions).
 * The accordion trigger is an unlabeled chevron to the right of the toggle
 * (an `accordionLabel` is still set as its accessible name) and only
 * appears once the toggle is on; it starts collapsed and expands on click.
 */
export function ToggleAccordionField({
  label,
  checked,
  onCheckedChange,
  accordionLabel = 'Instructions',
  children,
}: {
  label: string
  checked: boolean
  onCheckedChange: (next: boolean) => void
  accordionLabel?: string
  children: React.ReactNode
}) {
  return (
    <Accordion type="single" collapsible>
      <AccordionItem value="instructions" className="border-b-0">
        <div className="flex items-center justify-between gap-4">
          <Label className="flex items-center gap-2 font-normal">
            <Switch
              checked={checked}
              onCheckedChange={(next) => onCheckedChange(next === true)}
            />
            {label}
          </Label>
          {checked ? (
            <AccordionTrigger
              aria-label={accordionLabel}
              className="w-auto flex-none justify-center p-1"
            />
          ) : null}
        </div>
        {checked ? (
          <AccordionContent className="pt-2">
            <div className="flex flex-col gap-2">
              <Label>{accordionLabel}</Label>
              {children}
            </div>
          </AccordionContent>
        ) : null}
      </AccordionItem>
    </Accordion>
  )
}
